import { Box, LinearProgress } from '@material-ui/core';

export const Indicator = () => (
  <Box style={{ width: '100%', position: 'absolute', top: '0' }}>
    <LinearProgress style={{ height: '10px' }} />
  </Box>
);
